﻿import "eventlistener-polyfill";
import $ from "./dQuery";

export default function (toggleSelector: string = '.dropdown-toggle', menuSelector: string = '.dropdown-menu', showClass: string = 'show') {
    $(toggleSelector)
        .on('click', (e: Event) => {
            const menu = $(e.currentTarget as HTMLElement).next(menuSelector);
            if (!menu.hasClass(showClass)) {
                menu.addClass(showClass);
                setTimeout(() => {
                        $(document).once('click', () => menu.removeClass(showClass));
                    },
                    1);
            } else {
                menu.removeClass(showClass);
            }
        });
}

 